import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.incidents-counter2';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsIncidentsCounter2Effects {

    IncidentsCounter2$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_INCIDENTS_COUNTER2),
        mergeMap((x: ac.GetIncidentsCounter2Action) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getIncidentsCounter2(x.veranstaltung_id).pipe(
                map((result: any) => {
                    return new ac.GetIncidentsCounter2ErfolgreichAction(result, x.veranstaltung_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetIncidentsCounter2FehlerAction(error, x.veranstaltung_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsQueryService);
        }
        return this.service;
    }
}
